import { render, staticRenderFns } from "./FileDisplay.vue?vue&type=template&id=22200d15&scoped=true&"
import script from "./FileDisplay.vue?vue&type=script&lang=js&"
export * from "./FileDisplay.vue?vue&type=script&lang=js&"
import style0 from "./FileDisplay.vue?vue&type=style&index=0&id=22200d15&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22200d15",
  null
  
)

export default component.exports